(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('contacts-facility', {
                parent: 'entity',
                url: '/contacts-facility',
                data: {
                    authorities: [],
                    pageTitle: 'ContactsFacilities'
                },
                ncyBreadcrumb: {
                    label: 'Contacts Facility'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/contacts-facility/list/contacts-facility.html',
                        controller: 'ContactsFacilityController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    filter: ['CoreService', function (CoreService) {
                        return {
                            facilityId: CoreService.getCurrentFacility().id
                        }
                    }],
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_CONTACTS_FACILITY];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_CONTACTS_FACILITY, access);
                }]
            });
    }
})();
